import { request } from "../request.js";

// 频道列表
export function channelList(data) {
	return request({
		url: "/web/back/channel/pageList",
		method: "post",
		data,
	});
}

// 添加频道
export function addChannel(data) {
	return request({
		url: "/web/back/channel/insert",
		method: "post",
		data,
	});
}

// 更新频道
export function updateChannel(data) {
	return request({
		url: "/web/back/channel/update",
		method: "post",
		data,
	});
}

// 删除
export function delChannel(params) {
	return request({
		url: "/web/back/channel/delete",
		method: "delete",
		params,
	});
}

// 企业下拉列表
export function unitList() {
	return request({
		url: "/web/back/sys/unit/unitList",
		method: "get",
	});
}

// 关键字下拉  所有的未进行分也有的  有单独的分页列表   见下
export function keywordsList() {
	return request({
		url: "/web/back/keywords/list",
		method: "get",
	});
}

// 频道操作  审核关闭和开启  /back/channel/closeChannel?id=3&isClose=1
export function operateChannel(data) {
	return request({
		url: "/web/back/channel/closeChannel",
		method: "post",
		data,
	});
}

// 频道下的资源列表

export function resourcesList(data) {
	return request({
		url: "/web/back/docChannel/pageList",
		method: "post",
		data,
	});
}

// 添加资源
export function addResource(data) {
	return request({
		url: "/web/back/docChannel/insert",
		method: "post",
		data,
	});
}
// 添加文章接口
export function noChannelDoclistPage(data) {
	return request({
		url: "/web/back/sys/doc/noChannelDoclistPage",
		method: "post",
		data,
	});
}
// 删除频道下已添加文章 /web/back/sys/doc/noChannelDoclistPage
export function deleteChannelDoclist(data) {
	return request({
		url: "/web/back/docChannel/batch/delete",
		method: "delete",
		data,
	});
}

// 添加时候选择文章列表  unitId
export function doclist(params) {
	return request({
		url: "/web/back/sys/doc/noChannelDoclist",
		method: "get",
		params,
	});
}

// 更新资源
export function updateChannelResource(data) {
	return request({
		url: "/web/back/docChannel/update",
		method: "post",
		data,
	});
}

// 将文章从频道移除   docId
export function delChannelResource(params) {
	return request({
		url: "/web/back/docChannel/delete",
		method: "delete",
		params,
	});
}

// 关键字
//分页
export function keywordsPageList(data) {
	return request({
		url: "/web/back/keywords/listPage",
		method: "post",
		data,
	});
}

// 添加关键字
export function addKeyword(data) {
	return request({
		url: "/web/back/keywords/insert",
		method: "post",
		data,
	});
}

// 修改关键字
export function updateKeywords(data) {
	return request({
		url: "/web/back/keywords/update",
		method: "post",
		data,
	});
}

// 关键字删除
export function delKeywords(params) {
	return request({
		url: "/web/back/keywords/delete",
		method: "delete",
		params,
	});
}

// 频道图标 上传
export function upload(data) {
	return request({
		url: "/web/back/channel/uploadImg",
		method: "post",
		data,
	});
}

// 频道类型和收费模式
export function queryType() {
	return request({
		url: "/web/back/channel/queryType",
		method: "get",
	});
}
